import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/contact_management'
import * as AppActions from 'actions/app'

import {
  ContactManagementDistributionListsDataGridColumnVisibility
} from 'static/constants'

export const initialState = fromJS({
  settings: {
    density: 'standard',
    filterModel: {
      items: []
    },
    sortModel: [{
      field: 'createdAt',
      sort: 'desc'
    }],
    rowSelectionModel: [],
    columnVisibilityModel: ContactManagementDistributionListsDataGridColumnVisibility.DEFAULT,
    pageSizeOptions: [25, 50, 100],
    paginationModel: {
      page: 0,
      pageSize: 25
    }
  }
})

const clearSelection = state => state.setIn(['settings', 'rowSelectionModel'], fromJS([]))

const toggleRowSelection = (state, distributionList) => {
  const id = distributionList.get('id')
  const rowSelectionModel = state.getIn(['settings', 'rowSelectionModel'])
  const existingIndex = rowSelectionModel.findIndex(selectedId => String(selectedId) === String(id))

  if (existingIndex !== -1) {
    return state.setIn(['settings', 'rowSelectionModel'], rowSelectionModel.delete(existingIndex))
  }

  return state.setIn(['settings', 'rowSelectionModel'], rowSelectionModel.push(id))
}

export default handleActions(
  {
    [Actions.setSelectedMainTab]: (state, { payload }) => {
      // Reset selection if leaving 'distribution lists' tab
      if (payload === 'contacts') {
        return clearSelection(state)
      }

      return state
    },
    [Actions.setDistributionListsDataGridSettings]: (state, { payload: { key, value } }) => (
      state.setIn(['settings', key], fromJS(value))
    ),
    [Actions.selectDistributionList]: (state, { payload }) => toggleRowSelection(state, payload),
    [combineActions(
      Actions.clearSelectedDistributionLists,
      Actions.deleteDistributionListsSuccess,
      Actions.mergeDistributionListsSuccess,
      Actions.openDistributionListDetails
    )]: clearSelection,

    [combineActions(
      Actions.resetState,
      AppActions.resetState
    )]: () => initialState
  },
  initialState
)
